import React from 'react';
import { useSelector } from 'react-redux';

import ColumnFilter from '../column-filter/ColumnFilter';

function AudienceFilters({ selectedFilters, onApply }) {
  const filterColumns = useSelector((state) => state.resonance.filterColumns);

  return (
    <>
      {(filterColumns ?? []).map(({ type, header, audiences }) => (
        <ColumnFilter
          key={type}
          label={header}
          options={audiences}
          selectedOptions={selectedFilters}
          onApply={onApply}
        />
      ))}
    </>
  );
}

export default AudienceFilters;
